import { Fragment } from "react";
import {
    formatShortcut,
    type ShortcutPlatform,
} from "@design-system/Shortcut/formatShortcut";
import {
    ShortcutView,
    type ShortcutSize,
} from "@design-system/Shortcut/ShortcutView";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import styles from "./KeyboardShortcutsPlayground.module.scss";

const typeRows = [
    { id: "one", label: "One", keys: "k" },
    { id: "two", label: "Two", keys: "mod+k" },
    { id: "then", label: "Then", keys: "g>k" },
] as const;

const keyTypeKeys = [
    "k",
    "=",
    "enter",
    "mod",
    "shift",
    "arrowup",
    "arrowright",
    "arrowdown",
    "arrowleft",
    "escape",
    "alt",
];

const sizeColumns: ReadonlyArray<{ size: ShortcutSize; label: string }> = [
    { size: "md", label: "20px (md)" },
    { size: "sm", label: "16px (sm)" },
];

/** Figma's Shortcut set (Type x Size) plus every drawn key chip, per platform. */
export const ShortcutMatrix = ({
    platform,
}: {
    platform: ShortcutPlatform;
}) => (
    <VStack className={styles.matrix} gap={24} padding={24}>
        <h2 className={styles.matrixTitle}>Figma matrix</h2>
        <div className={styles.grid}>
            <span className={styles.columnHeader}>Type</span>
            {sizeColumns.map((column) => (
                <span key={column.size} className={styles.columnHeader}>
                    {column.label}
                </span>
            ))}
            {typeRows.map((row) => (
                <Fragment key={row.id}>
                    <span className={styles.rowLabel}>{row.label}</span>
                    {sizeColumns.map((column) => (
                        <div key={column.size} className={styles.cell}>
                            <ShortcutView
                                steps={formatShortcut(row.keys, platform)}
                                size={column.size}
                            />
                        </div>
                    ))}
                </Fragment>
            ))}
            <span className={styles.rowLabel}>Key types</span>
            {sizeColumns.map((column) => (
                <HStack
                    key={column.size}
                    className={styles.cell}
                    gap={8}
                    align="center"
                    wrap
                >
                    {keyTypeKeys.map((keys) => (
                        <ShortcutView
                            key={keys}
                            steps={formatShortcut(keys, platform)}
                            size={column.size}
                        />
                    ))}
                </HStack>
            ))}
        </div>
    </VStack>
);
